export default __webpack_public_path__ + "static/media/Creativity-bro.433fba36.svg";